import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Page from '@averyano/core/src/classes/Page';
import each from 'lodash/each';
import MultidimensionalGallery from '../../components/MultidimensionalGallery';
import PortfolioExperience from './Canvas/Experience';

export default class PortfolioPage extends Page {
	constructor(el) {
		super({
			element: el,
			elements: {
				viewport: '.portfolio__viewport',
			},
		});

		this.id = 'portfolio';
		this.isCreated = false;
	}

	create() {
		if (this.template !== this.id) return;
		if (!this.isReady) super.createComponent();

		if (!this.isCreated) {
			const gallery = new MultidimensionalGallery();
			this.components = {
				gallery,
				// experience reads gallery.scroll/scale each frame; gallery first
				experience: new PortfolioExperience('.webgl-portfolio', gallery),
			};
			this.isCreated = true;
		}

		super.create();
	}

	show() {
		this.$emit('stopScroll');
		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});
		window.scrollTo(0, 0);

		each(this.components, (c) => c.show && c.show());
	}

	hide() {
		return new Promise((resolve) => {
			this.$emit('startScroll');
			ScrollTrigger.getAll().forEach((t) => t.kill());
			each(this.components, (c) => c.hide && c.hide());
			GSAP.to(this.element, {
				autoAlpha: 0,
				duration: 1.5,
				ease: 'expo.out',
				onComplete: resolve,
			});
		});
	}

	update(time) {
		// MultidimensionalGallery self-drives an input rAF; only the WebGL
		// experience renders per-frame (capped to 60fps inside its update).
		if (this.template !== this.id) return;
		if (this.components && this.components.experience) {
			this.components.experience.update(time);
		}
	}

	onResize() {
		each(this.components, (c) => c.onResize && c.onResize());
	}

	addEventListeners() {}

	removeEventListeners() {}

	destroy() {
		each(this.components, (c) => c.destroy && c.destroy());
		this.components = null;
		this.isCreated = false;
		super.destroy();
	}
}
